import axios from 'axios';

// 同源部署,baseURL 为空即可(由 server.js 处理路由)
export const API = axios.create({
  baseURL: '',
  withCredentials: true,  // 发送 admin_token cookie
  // 超时兜底:后台有备份/恢复/清理这类可能跑几分钟的接口,给足时间;
  // 但也不能无限挂住 —— 挂死的请求在移动网络下会表现成"转圈半天没反应"。
  timeout: 180000,
});

// 业务 Key 的 axios 实例(不发送 cookie,只发 Authorization 头)
export const API_USER = axios.create({
  baseURL: '',
  withCredentials: false,
  timeout: 300000, // 流式请求可能很长,单独放宽
});

// ---------------------------------------------------------------------------
// 统一错误处理
//
// 之前后台各页面大量写成 `.then(...).finally(...)` 却没有 `.catch(...)`,
// 一旦网络抖动 / 登录态过期 / 服务器断开,axios 的 reject 就变成
// "未捕获的 Promise 异常",被 public/index.html 的全局监听器渲染成
// 一大块红色错误框盖住整个页面(用户手机端截图里的
// 「未捕获的 Promise 异常: Network Error」就是这条路径)。
//
// 这里做两件事:
//   1. 拦截器把错误标记成 __apiError,并算出可读文案 apiMsg;
//   2. 提供 apiErrMsg(err) 给各页面 catch 里用,保证提示口径一致。
// 注意:标记只是"识别",真正不弹红框靠的是页面自己 catch ——
// 但即便漏了 catch,全局监听器也会因为这个标记而不再甩原始堆栈。
// ---------------------------------------------------------------------------

const API_MSG = '请求失败,请稍后重试';
const NET_MSG = '网络连接失败,请检查网络后重试';

export function apiErrMsg(err) {
  if (!err) return API_MSG;
  // 业务错误:后端给了 message
  const msg = err?.response?.data?.message;
  if (msg && typeof msg === 'string') return msg;
  if (err?.response?.status === 401 || err?.response?.status === 403) {
    return '登录状态已失效,请重新登录';
  }
  if (err?.code === 'ECONNABORTED') return '请求超时,服务器响应太慢,请稍后重试';
  if (err?.message === 'Network Error' || !err?.response) {
    return '网络连接失败,请检查网络后重试';
  }
  if (err?.response?.status >= 500) return '服务器开小差了,请稍后重试';
  return err?.message || API_MSG;
}

function markApiError(err) {
  if (err && typeof err === 'object' && !err.__apiError) {
    try {
      Object.defineProperty(err, '__apiError', { value: true, enumerable: false, configurable: true });
      Object.defineProperty(err, 'apiMsg', { value: apiErrMsg(err), enumerable: false, configurable: true });
    } catch (_) { /* 冻结对象等极端情况忽略 */ }
  }
  return err;
}

[API, API_USER].forEach((inst) => {
  inst.interceptors.response.use(
    (r) => r,
    (err) => Promise.reject(markApiError(err)),
  );
});
